import NarrativeClusterTabContentManagementPanel from "@/components/discovery/discovery-content-control-panels/NarrativeClustersTabContentManagementPanel";
import NarrativeClustersTable from "@/components/discovery/narrative-clusters-table/NarrativeClustersTable";

/**
 * Narrative Clusters tab content for Discovery (nav v2).
 * Placeholder until NC view is implemented.
 */
const NarrativeClustersTab = () => (
  <div className="flex min-h-0 flex-1 flex-col">
    <NarrativeClusterTabContentManagementPanel />
    <div className="min-h-0 flex-1">
      <NarrativeClustersTable />
    </div>
  </div>
);

export default NarrativeClustersTab;
